import { findIndex, propEq } from 'ramda'

class RatingController {
  /* @ngInject */
  constructor (worker, UsersService, $mdDialog, $mdToast) {
    this.worker = worker
    this.UsersService = UsersService
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.rating
    this.note
  }

  onFormSubmit () {
    if (this.note) {
      const confirm = this.$mdDialog.confirm({
        title: 'Confirm candidate endorsement, please note this will be visible to clients and candidates',
        ok: 'Confirm',
        cancel: 'Cancel',
        multiple: true
      })
      return this.$mdDialog.show(confirm)
      .then(() => {
        return this.saveRating()
      })
      .catch(() => {})
    } else {
      this.saveRating()
    }
  }
  saveRating () {
    this.UsersService.rate(this.rating, [this.worker.external_id])
    .then(() => {
      if (this.note) {
        this.UsersService.addNote(this.worker.external_id, this.note, true)
      }
      this.worker.rating = this.rating
      this.$mdDialog.hide(this.rating)
      this.$mdToast.showSimple('Worker rating updated.')
    })
    .catch(err => {
      if (!err) return
      debug(err)
      this.$mdToast.showSimple('Failed To Update worker rating')
    })
  }

  cancel () {
    this.$mdDialog.cancel()
  }
}

export default RatingController
